import WebUserModal from './WebUserModal';

const generalManagement = {
  WebUserModal,
}
export default generalManagement;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/generalManagement/index.js